import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DefaultNavBar from "components/Navbars/DefaultNavBar.js";
import LegalHeader from "components/Headers/LegalHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

function TermsOfServicePage(props) {
  React.useEffect(() => {
    document.body.classList.add("legal-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("legal-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <DefaultNavBar {...props} />
      <div className="wrapper">
        <LegalHeader title="Terms of Service" />
        <div className="section">
          <Container className="legal-content">
            <Row className="justify-content-center">
              <Col md="10" lg="8">
                <p className="last-updated">Last updated: October 18, 2026</p>
                <p>
                  These Terms of Service ("Terms") govern your use of
                  unlimitedtransportation.com (the "Site") and the text
                  messaging program operated by Unlimited Transportation Corp.
                  ("Unlimited Transportation," "we," "us," or "our"). By using
                  the Site or enrolling in our text messaging program, you agree
                  to these Terms. If you do not agree, please do not use the Site.
                </p>

                <h3>1. Use of the Site</h3>
                <p>
                  You may use the Site for lawful purposes only, such as learning
                  about our services, requesting a quote, contacting us, or
                  applying for a job. You agree not to misuse the Site, interfere
                  with its operation, attempt to gain unauthorized access to it,
                  or submit information that is false or that you do not have the
                  right to share.
                </p>

                <h3>2. Quotes and Service Requests</h3>
                <p>
                  Quote requests and messages submitted through the Site are not
                  binding agreements. Rates, availability, and service details are
                  confirmed directly by our team, and transportation services are
                  governed by the applicable rate confirmation, bill of lading, or
                  other written agreement between you and Unlimited Transportation.
                </p>

                <h3>3. SMS Messaging Terms</h3>
                <p>
                  Unlimited Transportation uses text messaging to communicate with
                  its employees about dispatch and delivery work. This program is
                  for Unlimited Transportation employees only. We do not send
                  marketing or promotional text messages.
                </p>
                <ul>
                  <li>
                    <b>Program description:</b> Enrolled employees receive text
                    messages about their dispatch and delivery assignments, such
                    as requests for their ETA to a pickup location, confirmation
                    that a customer has received a package, and delivery in and
                    out times.
                  </li>
                  <li>
                    <b>Consent:</b> Employees opt in by providing their mobile
                    phone number to Unlimited Transportation and agreeing in
                    writing to receive text messages. Job applicants may also opt
                    in by checking the text message consent box on our online job
                    application; messages begin only if they are hired. Consent is
                    voluntary and is not a condition of employment.
                  </li>
                  <li>
                    <b>Message frequency:</b> Message frequency varies.
                  </li>
                  <li>
                    <b>Cost:</b> Message and data rates may apply.
                  </li>
                  <li>
                    <b>Opt out:</b> You can opt out at any time by replying STOP.
                    You will receive one final message confirming that you have
                    been unsubscribed, and no further messages will be sent. To
                    resubscribe, reply START.
                  </li>
                  <li>
                    <b>Help:</b> Reply HELP for help, or contact us
                    at <a href="tel:614-351-0400">(614) 351-0400</a> or <a href="mailto:info@unlimitedtransportation.com">info@unlimitedtransportation.com</a>.
                  </li>
                  <li>
                    <b>Carrier liability:</b> Carriers are not liable for delayed
                    or undelivered messages.
                  </li>
                  <li>
                    <b>Privacy:</b> No mobile information will be shared with
                    third parties or affiliates for marketing or promotional
                    purposes. Text messaging opt-in data and consent will not be
                    shared with any third parties. See our <a href="/privacy">Privacy Policy</a> for
                    details.
                  </li>
                </ul>

                <h3>4. Intellectual Property</h3>
                <p>
                  The Site and its content, including text, images, logos, and
                  design, are owned by or licensed to Unlimited Transportation and
                  are protected by intellectual property laws. You may not copy,
                  reproduce, or distribute Site content without our written
                  permission.
                </p>

                <h3>5. Third-Party Links</h3>
                <p>
                  The Site links to third-party websites and services, such as
                  payment providers and government resources. We are not
                  responsible for their content or practices, and your use of
                  them is governed by their own terms.
                </p>

                <h3>6. Disclaimer</h3>
                <p>
                  The Site is provided "as is" and "as available." We work to
                  keep the information on the Site accurate and current, but we
                  make no warranties of any kind, express or implied, about the
                  Site or its content.
                </p>

                <h3>7. Limitation of Liability</h3>
                <p>
                  To the fullest extent permitted by law, Unlimited Transportation
                  will not be liable for any indirect, incidental, special, or
                  consequential damages arising out of or related to your use of
                  the Site or our text messaging program.
                </p>

                <h3>8. Governing Law</h3>
                <p>
                  These Terms are governed by the laws of the State of Ohio,
                  without regard to its conflict-of-law rules.
                </p>

                <h3>9. Changes to These Terms</h3>
                <p>
                  We may update these Terms from time to time. When we do, we will
                  post the updated Terms on this page and change the "Last
                  updated" date above.
                </p>

                <h3>10. Contact Us</h3>
                <p>
                  Unlimited Transportation Corp.
                  <br />
                  2151–2181 International St
                  <br />
                  Columbus, OH 43228
                  <br />
                  Office: <a href="tel:614-351-0400">(614) 351-0400</a>
                  <br />
                  Email: <a href="mailto:info@unlimitedtransportation.com">info@unlimitedtransportation.com</a>
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default TermsOfServicePage;
